import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {gsap} from "gsap";
import {KennethMustDie} from "../../KennethMustDie";
import {KMDSound} from "../../sound/KMDSound";

export class KMDAvalancheIdlePresentation implements FlowStatePresentation {

    public start(flowStateController: FlowStateController): void {
        const tl: gsap.core.Timeline = gsap.timeline({
            onComplete: () => {
                flowStateController.finish();
            }
        });

        tl.to(this, {
            duration: 0.01
        });
        tl.add(() => {
            KennethMustDie.apiPlugin.betHandler.zeroBet();

            // any of the fs mode
            if (KennethMustDie.model.data.mode.indexOf("FREESPIN") > -1) {
                if (!KennethMustDie.model.isRestore) {
                    KennethMustDie.keypadPlugin.setZeroBetSpinCounter(KennethMustDie.model.gameData.freespinsLeft);
                } else {
                    KennethMustDie.keypadPlugin.setZeroBetSpinCounter(KennethMustDie.model.initData.freespinsLeft);
                }
            } else if (!KennethMustDie.model.data.wasFeatureBuy && ((KennethMustDie.s1CountReelStop === 3) || (KennethMustDie.s1CountReelStop === 2 && this.checkIfAnyNonS1ReelCanFillUp()))) { // #485
                const s1Positions: number[] = KennethMustDie.model.s1Positions;
                for (let i: number = 0; i < s1Positions.length; i++) {
                    if (s1Positions[i] > -1) {
                        KennethMustDie.nearWinAnticipation.playAnticipateFireAnimation(i, s1Positions[i] + 1, 0);
                    }
                }

                // #485
                if (KennethMustDie.s1CountReelStop === 3 && KennethMustDie.model.s2Feature.originReelId > -1) {
                    KennethMustDie.nearWinAnticipation.playAnticipateFireAnimation(4, KennethMustDie.model.s2Feature.originSymId + (KennethMustDie.model.isRestore ? 0 : 1), 0); // #544
                }

                if (KennethMustDie.model.isSFSTriggered) {
                    KennethMustDie.nearWinAnticipation.playXHAnticipateFireAnimation(0);
                }

                // #529
                KennethMustDie.soundPlayer.playSound(KMDSound.SCATTER_FIRE);
            }
        });
    }

    // #485
    private checkIfAnyNonS1ReelCanFillUp(): boolean {
        for (let i: number = 1; i < (KennethMustDie.REELS_NUM - 1); i++) {
            if (KennethMustDie.model.s1Positions[i] > -1) {
                continue;
            }

            if (KennethMustDie.reelView.reelModels[i].avalancheSymbolsRemoved > 0) {
                return true;
            }
        }

        return false;
    }
}